<footer>
  <div class="footer mt-5 d-flex flex-column container-fluid">
    <div class="">
      <div class="row subscription d-flex justify-content-between">
        <form class="col-md-6">
          <div class="subscription-form d-flex">
            <label for="newsletter1" class="visually-hidden"
              >Email address</label
            >
            <input
              id="newsletter1"
              type="text"
              class="form-control"
              placeholder="ادخل البريد الالكتروني الخاص بك حتي نرسل لك احدث الاخبار"
              [formControl]="email"
            />
            <button (click)="send()" style="width: 130px" class="btn btn-primary" type="button">
              أشترك الآن
            </button>
          </div>
        </form>
        <ul
          class="col-md-6 list-unstyled d-flex justify-content-lg-end justify-content-md-center"
        >
          <li class="ms-3" *ngFor="let item of contactData?.flatData?.ourSocialMedia">
            <a class="link-dark" [href]="item?.value" target="_blank">
              <img [src]="item?.type[0]?.flatData?.lightLogo[0]?.url">
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-contact row d-flex justify-content-around">

        <h3 class="phone col-lg-4 text-gray" *ngFor="let itemdata of contactData?.flatData?.ourContacts">
          <strong class="custom-color">
            <img [src]="itemdata?.type[0]?.flatData?.lightLogo[0]?.url">
            {{itemdata?.name}}</strong
          >
          <span class="interpolation">{{itemdata?.value}}</span>
        </h3>


      </div>
      <hr style="color: white" />
      <div class="row footer-info">
        <div class="container-fluid row col-lg-9">
          <div class="my-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 xs-6">
            <h1>عن المركز</h1>
            <ul>
              <li>
                <a routerLink="about/establishment">{{DataAbout[0]?.flatData?.aboutTitle}}</a>
              </li>
              <li>
                <a routerLink="about/vision">{{DataAbout[0]?.flatData?.missionVisionSectionTitle}}</a>
              </li>
              <li>
                <a routerLink="about/standards"> {{DataAbout[0]?.flatData?.goalsSectionTitle}}</a>
              </li>
              <li>
                <a routerLink="about/team-work">{{DataAbout[0]?.flatData?.teamMembersSectionTitle}} </a>
              </li>
              <li>
                <a routerLink="about/annual-reports">{{DataAbout[0]?.flatData?. annualReportSectionTitle}} </a>
              </li>
            </ul>
          </div>
          <div class="my-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 xs-6">
            <h1>{{pupdata[0]?.flatData?.pageTitle}}</h1>
            <ul>
              <li>
                <a routerLink="versions/economiclacapsules"> {{pupdata[0]?.flatData?.economicCapsulesSectionTitle}}</a>
              </li>
              <li>
                <a routerLink="versions/studies">  {{pupdata[0]?.flatData?.economicResearchesSectionTitle}}</a>
              </li>
              <li>
                <a routerLink="versions/economy-index">{{pupdata[0]?.flatData?.economicIndicatorsSectionTitle}}</a>
              </li>
              <li>
                <a routerLink="versions/country-files">{{pupdata[0]?.flatData?.economicCountryReportsSectionTitle}} </a>
              </li>
            </ul>
          </div>
          <div class="my-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 xs-6">
            <h1> {{eventdata[0]?.flatData?.pageTitle}}</h1>
            <ul>
              <li>
                <a routerLink="events/exhibitions"> {{eventdata[0]?.flatData?.conferencesSectionTitle}} </a>
              </li>
              <li>
                <a routerLink="events/seminars">  {{eventdata[0]?.flatData?.coursesSectionTitle}}  </a>
              </li>
              <li>
                <a routerLink="events/lectures">  {{eventdata[0]?.flatData?.seminarsSectionTitle}}  </a>
              </li>
            </ul>
          </div>
          <div class="my-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 xs-6">
            <h1>روابط هامة</h1>
            <ul>
              <li>
                <a routerLink="events/exhibitions">المؤتمرات والمعارض</a>
              </li>
              <li>
                <a routerLink="events/seminars">المؤتمرات و ورش العمل</a>
              </li>
              <li>
                <a routerLink="events/lectures">محاضرات </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3">
          <!-- <img class="map" src="/assets/images/map.png" /> -->

          <google-map  [options]="options" hight="500px">

            <map-marker

  [position]="options?.center"></map-marker>
        
            </google-map>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-white w-100" style="border: 5px solid white ;"></div>
  <div class="row text-white  p-3 d-flex align-items-baseline" style="background-color: #041364;">
    <div class="col-md-6 container-fluid">
      <img src="../../../assets/images/MainLogo 1.png">
      <span>مركز الاسكندرية للدراسات الاقتصادية</span>
    </div>
    <div class="col-md-6">
      <img src="../../../assets/images/cc.svg">
      <span>   تم التطوير بواسطة شركة V.1.3.0 - Softprograms Technology </span>
    </div>

  </div>
</footer>
